// extracted by mini-css-extract-plugin
export default {"fullCenter":"FullCenter_fullCenter__n855t","centerY":"FullCenter_centerY__c-6cn"};